import liveca from '../assets/partners/liveca.png'
import gba from '../assets/partners/gba.png'
import beancounter from '../assets/partners/beancounter.png'
import afaccounting from '../assets/partners/afaccounting.png'
import aktif from '../assets/partners/Aktif.png'
import xen from '../assets/partners/Xen.png'
import blackmere from '../assets/partners/blackmere.png'
import moiramilligan from '../assets/partners/moiramilligan.png'
import dexteritas from '../assets/partners/DexteritasAccounting.png'
import baranov from '../assets/partners/BaranovCPA.png'
import integral from '../assets/partners/IntegralAccounting.png'
import nsi from '../assets/partners/NSIAccounting.png'
import musicbynumbers from '../assets/partners/MusicbyNumbers.png'
import dw from '../assets/partners/DWAssociates.png'
import gomes from '../assets/partners/Gomes.png'
import orangeoranges from '../assets/partners/OrangeOranges.jpg'

export type Partner = {
  name: string
  city: string
  /** province code: AB | BC | ON | QC */
  prov: 'AB' | 'BC' | 'ON' | 'QC'
  blurb: string
  url: string
  logo: string
}

// Real listings from the simplepay.ca Pro Partner directory, with the
// partner's own logo and website.
export const partners: Partner[] = [
  {
    name: 'LIVECA',
    city: 'Toronto',
    prov: 'ON',
    blurb:
      "Fixed-fee, fully paperless accounting for Canadians. LIVECA helps clients shift their accounting onto online platforms — less time on paper documents, more time on value-added work.",
    url: 'http://www.liveca.ca/',
    logo: liveca,
  },
  {
    name: 'GBA LLP',
    city: 'Georgetown',
    prov: 'ON',
    blurb:
      'Chartered Professional Accountants delivering proactive, fixed-fee solutions — bricks-and-mortar in the GTA or fully in the cloud, leveraging technology to add value to your business.',
    url: 'http://www.gba-llp.ca/',
    logo: gba,
  },
  {
    name: 'The StoryTelling BeanCounter',
    city: 'Oshawa',
    prov: 'ON',
    blurb:
      'There is a story behind the numbers. Narrative reporting and financial storytelling that help owners understand, interpret and act on their financial information.',
    url: 'http://www.storytellingbeancounter.com/',
    logo: beancounter,
  },
  {
    name: 'AF Accounting',
    city: 'Montreal',
    prov: 'QC',
    blurb:
      'A contemporary firm offering a complete suite of accounting expertise to professionals, startups and small businesses — simplifying accounting by leveraging technology.',
    url: 'http://www.afaccounting.ca/',
    logo: afaccounting,
  },
  {
    name: 'Aktif, CPA',
    city: 'Montreal',
    prov: 'QC',
    blurb:
      'Cabinet de comptables professionnels agréés au service des particuliers et des entreprises du grand Montréal. A full range of advisory and accounting services, in English and French.',
    url: 'http://www.aktif-cpa.com/',
    logo: aktif,
  },
  {
    name: 'Xen Accounting',
    city: 'Montreal',
    prov: 'QC',
    blurb:
      'A 100% virtual CPA firm for micro businesses, consultants and freelancers — fixed monthly fee, unlimited CPA consultation, cloud accounting and real-time financials.',
    url: 'http://www.xenaccounting.com/',
    logo: xen,
  },
  {
    name: 'Blackmere Brothers Accounting',
    city: 'Bolton',
    prov: 'ON',
    blurb:
      'A small family-owned firm helping companies organize accounting, bookkeeping and payroll — from full "accounting department for hire" to corporate tax filing and CRA navigation.',
    url: 'http://www.blackmere.ca/',
    logo: blackmere,
  },
  {
    name: 'Moira Milligan, CPB',
    city: 'Delta',
    prov: 'BC',
    blurb:
      'Certified Public Bookkeeper offering online bookkeeping and advisory services — SimplePay payroll integrated with Xero, with trusted-advisor support for small business.',
    url: 'https://www.moiramilligan.com/',
    logo: moiramilligan,
  },
  {
    name: 'Dexteritas Professional Corporation',
    city: 'Calgary',
    prov: 'AB',
    blurb:
      'No more shoebox. A full-service CPA firm providing assurance, compilation and advisory services — turning financial data into strategic insight for growth and long-term wealth.',
    url: 'https://dexteritas.ca/',
    logo: dexteritas,
  },
  {
    name: 'Baranov CPA',
    city: 'Toronto',
    prov: 'ON',
    blurb:
      'Canadian eCommerce accountants helping online sellers with systems integrations, sales taxes and complex accounting across Amazon, Shopify, Stripe, PayPal and more.',
    url: 'https://baranovcpa.ca',
    logo: baranov,
  },
  {
    name: 'Integral Accounting',
    city: 'Vernon',
    prov: 'BC',
    blurb:
      'A boutique CPA firm at the intersection of accounting and technology — outsourced CFO/Controller services and cloud accounting for non-profits, local governments and small businesses.',
    url: 'http://integralaccounting.net',
    logo: integral,
  },
  {
    name: 'NSI Accounting & Financial Services',
    city: 'Airdrie',
    prov: 'AB',
    blurb:
      'Customer-focused tax preparation, planning and accounting for corporations, small and medium businesses, individuals and not-for-profits across Canada and abroad.',
    url: 'https://nsiaccounting.com',
    logo: nsi,
  },
  {
    name: 'Music By Numbers',
    city: 'Montreal',
    prov: 'QC',
    blurb:
      'A boutique consulting firm offering financial management for companies and artists in the entertainment industry — so you can focus on creation.',
    url: 'https://www.musicbynumbers.com/en-home',
    logo: musicbynumbers,
  },
  {
    name: 'DW & Associates, CPA',
    city: 'Burnaby',
    prov: 'BC',
    blurb:
      'Chartered Professional Accountants serving small and medium enterprises across Metro Vancouver — bookkeeping, tax preparation and advisory services, approved under CPABC.',
    url: 'https://dw-accounting.com/',
    logo: dw,
  },
  {
    name: 'Gomes CPA',
    city: 'Mississauga',
    prov: 'ON',
    blurb:
      '20 years of experience. Personal and professional accounting in the hands of experienced, accredited accountants.',
    url: 'https://www.gomescpa.com/',
    logo: gomes,
  },
  {
    name: 'Orange Oranges Technologies',
    city: 'Surrey',
    prov: 'BC',
    blurb:
      'Digital technology services built on integrity, the human touch and technologist values — enterprise-grade solutions across disciplines.',
    url: 'https://www.orangeoranges.ca',
    logo: orangeoranges,
  },
]
